import React, { useState } from 'react'
import { Button, Modal, Progress, Select, Input } from "antd"
import { updateInfoBox } from '../../../services/api/apiNextBox'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

function AddSizeWeightModal(props) {
    const { visible, onCancel, selectedItems, setSelectedItems, reload } = props
    const [loading, setLoading] = useState(false)
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])
    const [weight, setWeight] = useState(0)
    const [height, setHeight] = useState(0)
    const [width, setWidth] = useState(0)
    const [length, setLength] = useState(0)


    const _onChangeWeightSize = async (boxId, isFinish) => {
        if(!isFinish){
            try {
                const data = {
                    confirm_update_fba_info: false,
                }
                if(weight) data.weight = weight
                if(height && length && width) data.dimension = {
                    width: width,
                    height: height,
                    length: length,
                }
    
                const { data: response } = await updateInfoBox({boxId, data})
    
                const { success, message } = response
    
                if (!success) {
                    return { success: success, message: message }
                }
    
                return { success: success }
            } catch (e) {
                return { success: false, message: e.message }
            }
        }else{
            return {success: false, message: 'Thông tin cân nặng, kích thước thực tế của thùng đã kết thúc cập nhật!'}
        }
    }

    const _onSubmitChange = async () => {
        setLoading(true)
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i => {
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))

        let processed = []

        await Promise.all(selectedItems.map(async item => {
            const response = await _onChangeWeightSize(item.id, item.is_finish_update_fba_info)

            const { success, message } = response

            if (!success) return processed.push({ ...item, error: message, processing: false })

            return processed.push({ ...item, success: true, processing: false })
        }))

        let newListSuccess = []
        let newListError = []

        processed.map(process => {
            if (process.success === true) {
                return newListSuccess.push(process)
            }

            if (process.error.length > 0) {
                return newListError.push(process)
            }
        })
        
        reload()
        setListSuccess(newListSuccess)
        setListError(newListError)
        setLoading(false)
        setSelectedItems(processed)
    }

    const handleCloseModal = () => {
        onCancel('SizeWeightModal')
        setWeight(0)
        setHeight(0)
        setLength(0)
        setWidth(0)
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i => {
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))
    }

    const _handleChangeInput = (key, value) => {
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i => {
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))
        if (key === 'weight') { setWeight(value) }
        if (key === 'height') { setHeight(value) }
        if (key === 'length') { setLength(value) }
        if (key === 'width') { setWidth(value) }
    }

    const canSave = !!weight && !!height && !!length && !!width
    const disableSave = loading || !canSave || (!!listSuccess.length || !!listError.length)

    return (
        <Modal
            className="AddSizeWeightModal"
            visible={visible}
            title="Thêm thông tin kích thước, cân nặng"
            onOk={_onSubmitChange}
            width='780px'
            onCancel={handleCloseModal}
            footer={[
                <Button key="back" disabled={loading} onClick={handleCloseModal}>
                    Cancel
                </Button>,
                <Button key="submit" disabled={disableSave} type="primary" loading={loading} onClick={_onSubmitChange}>
                    Save
                </Button>
            ]}
        >
            <div className="Form mb-3">
                <div className="FormItem Weight mb-3">
                    <h5 className='font-weight-bold'>Cân nặng thực tế: </h5>
                    <Input
                        value={weight || ''}
                        type='number'
                        placeholder='Nhập cân nặng thực của thùng'
                        allowClear
                        addonAfter="kg"
                        onChange={({ target: { value } }) => _handleChangeInput('weight', value)}
                    />
                </div>

                <div className="FormItem Size mb-3">
                    <h5 className='font-weight-bold'>Kích thước thực tế: </h5>
                    <div className='d-flex align-items-center'>
                        <Input
                            value={length || ''}
                            type='number'
                            className='Length'
                            placeholder='Chiều dài'
                            allowClear
                            addonAfter="cm"
                            onChange={({ target: { value } }) => _handleChangeInput('length', value)}
                        /> x
                        <Input
                            value={width || ''}
                            type='number'
                            className='Width'
                            placeholder='Chiều rộng'
                            allowClear
                            addonAfter="cm"
                            onChange={({ target: { value } }) => _handleChangeInput('width', value)}
                        /> x
                        <Input
                            value={height || ''}
                            type='number'
                            className='Height'
                            placeholder='Chiều cao'
                            allowClear
                            addonAfter="cm"
                            onChange={({ target: { value } }) => _handleChangeInput('height', value)}
                        />
                    </div>
                </div>
            </div>
            <h3>List processing <span>{selectedItems.length}</span> items</h3>
            {
                (listSuccess.length > 0 || listError.length > 0) &&
                <div className="Results">
                    <div className="ResultSuccess">
                        Success: <span>{listSuccess.length}</span> items
                    </div>
                    <div className="ResultError">
                        Error: <span>{listError.length}</span> items
                    </div>
                </div>
            }

            <div className="ListProcessing">
                <ul>
                    {
                        !!selectedItems && selectedItems.length > 0 && selectedItems.map(item => (
                            <li key={item._id}>
                                <span className='font-weight-bold'>#{item.id}</span>
                                {
                                    !!item.error &&
                                    <span className="Error"><ExclamationCircleOutlined /> {item.error}</span>
                                }
                                {
                                    item.success &&
                                    <span className="Success"><CheckCircleOutlined /> Change success</span>
                                }
                                <Progress
                                    percent={(!!item.success || !!item.error) ? 100 : 0}
                                    size="small"
                                    status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && item.error.length > 0) ? 'exception' : 'active')}`}
                                    showInfo={false}
                                />
                            </li>
                        )
                        )
                    }
                </ul>
            </div>
        </Modal>
    )
}

export default AddSizeWeightModal